import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    explore: "Explorar",
    organizations: "Organizaciones",
    suggestions: "Sugerencias",
    games: "Juegos",
    login: "Iniciar sesión",
    publish: "Publicar evento",
    myPanel: "Mi panel",
    menu: "Menú",
  },
  en: {
    explore: "Explore",
    organizations: "Organizations",
    suggestions: "Suggestions",
    games: "Games",
    login: "Log in",
    publish: "Post an event",
    myPanel: "My dashboard",
    menu: "Menu",
  },
});
